module.exports = __webpack_public_path__ + "img/ktip.09ad21a2.jpeg";